import { cn } from "@/lib/utils";
import {
  playStyleCategoryNamesSelector,
  playStylesSelector,
} from "@/redux/players/playersSlice";
import { useTranslation } from "@repo/shared/i18n";
import { useSelector } from "react-redux";

import { GridBox } from "../../DetailedPlayer";
import { Row } from "../components/Row";
import { PlayStyle } from "./Shared";

export const DetailedPlayStylesSection = ({
  playStylesPlus,
  playStyles,
  isGk,
}: {
  playStylesPlus: number[];
  playStyles: number[];
  isGk: boolean;
}) => {
  const playStylesAsList = useSelector(playStylesSelector);
  const categoryNames = useSelector(playStyleCategoryNamesSelector);
  const { t } = useTranslation("players");
  return (
    <GridBox
      title={t("detailed.playStyles.title")}
      className={cn(
        "col-span-4 touch-device:col-span-2  hidden mobile:block",
        isGk ? "min-h-[394px]" : "min-h-[318px]",
      )}
    >
      <div className="flex flex-col">
        <Row
          title={
            // eslint-disable-next-line i18next/no-literal-string -- fallback for a missing labels-dict entry
            categoryNames.Finishing ?? categoryNames.Scoring ?? "Finishing"
          }
          height="h-14"
          stretch
          playStyleRow
          value={
            <div className="flex flex-row gap-x-2">
              {playStylesAsList
                .filter(
                  (p) => p.category === "Scoring" || p.category === "Finishing",
                )
                .map((p) => {
                  const hasPlus = playStylesPlus?.includes(p.id);
                  const hasNormal = playStyles?.includes(p.id);
                  return (
                    <PlayStyle
                      hasPlus={hasPlus}
                      hasNormal={hasNormal}
                      id={p.id}
                      key={p.id}
                    />
                  );
                })}
            </div>
          }
        />
        <Row
          title={
            // eslint-disable-next-line i18next/no-literal-string -- fallback for a missing labels-dict entry
            categoryNames["Passing"] ?? "Passing"
          }
          height="h-14"
          stretch
          playStyleRow
          value={
            <div className="flex flex-row gap-x-2">
              {playStylesAsList
                .filter((p) => p.category === "Passing")
                .map((p) => {
                  const hasPlus = playStylesPlus?.includes(p.id);
                  const hasNormal = playStyles?.includes(p.id);
                  return (
                    <PlayStyle
                      hasPlus={hasPlus}
                      hasNormal={hasNormal}
                      id={p.id}
                      key={p.id}
                    />
                  );
                })}
            </div>
          }
        />
        <Row
          title={
            // eslint-disable-next-line i18next/no-literal-string -- fallback for a missing labels-dict entry
            categoryNames["Defending"] ?? "Defending"
          }
          height="h-14"
          stretch
          playStyleRow
          value={
            <div className="flex flex-row gap-x-2">
              {playStylesAsList
                .filter((p) => p.category === "Defending")
                .map((p) => {
                  const hasPlus = playStylesPlus?.includes(p.id);
                  const hasNormal = playStyles?.includes(p.id);
                  return (
                    <PlayStyle
                      hasPlus={hasPlus}
                      hasNormal={hasNormal}
                      id={p.id}
                      key={p.id}
                    />
                  );
                })}
            </div>
          }
        />
        <Row
          title={
            // eslint-disable-next-line i18next/no-literal-string -- fallback for a missing labels-dict entry
            categoryNames["Ball Control"] ?? "Ball Control"
          }
          height="h-14"
          stretch
          playStyleRow
          value={
            <div className="flex flex-row gap-x-2">
              {playStylesAsList
                .filter((p) => p.category === "Ball Control")
                .map((p) => {
                  const hasPlus = playStylesPlus?.includes(p.id);
                  const hasNormal = playStyles?.includes(p.id);
                  return (
                    <PlayStyle
                      hasPlus={hasPlus}
                      hasNormal={hasNormal}
                      id={p.id}
                      key={p.id}
                    />
                  );
                })}
            </div>
          }
        />
        <Row
          title={
            // eslint-disable-next-line i18next/no-literal-string -- fallback for a missing labels-dict entry
            categoryNames["Physical"] ?? "Physical"
          }
          height="h-14"
          stretch
          playStyleRow
          hiddenBorder={!isGk}
          value={
            <div className="flex flex-row gap-x-2">
              {playStylesAsList
                .filter((p) => p.category === "Physical")
                .map((p) => {
                  const hasPlus = playStylesPlus?.includes(p.id);
                  const hasNormal = playStyles?.includes(p.id);
                  return (
                    <PlayStyle
                      hasPlus={hasPlus}
                      hasNormal={hasNormal}
                      id={p.id}
                      key={p.id}
                    />
                  );
                })}
            </div>
          }
        />
        {isGk && (
          <Row
            title={
              // eslint-disable-next-line i18next/no-literal-string -- fallback for a missing labels-dict entry
              categoryNames.Goalkeeper ?? "Goalkeeping"
            }
            height="h-14"
            stretch
            playStyleRow
            hiddenBorder
            value={
              <div className="flex flex-row gap-x-2">
                {playStylesAsList
                  .filter((p) => p.category === "Goalkeeper")
                  .map((p) => {
                    const hasPlus = playStylesPlus?.includes(p.id);
                    const hasNormal = playStyles?.includes(p.id);
                    return (
                      <PlayStyle
                        hasPlus={hasPlus}
                        hasNormal={hasNormal}
                        id={p.id}
                        key={p.id}
                      />
                    );
                  })}
              </div>
            }
          />
        )}
      </div>
    </GridBox>
  );
};
